import { render } from "./DOCModal.vue?vue&type=template&id=3ac3e85e&scoped=true"
import script from "./DOCModal.vue?vue&type=script&lang=js"
export * from "./DOCModal.vue?vue&type=script&lang=js"

import "./DOCModal.vue?vue&type=style&index=0&id=3ac3e85e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ac3e85e"]])

export default __exports__